import SecondaryNavWeddingShopData from './SecondaryNavWeddingShopData';
import SecondaryNavRegistryData from './secondaryNavRegistryData';

const initNavData = ({
  user,
  showPromo,
  fetchUserContext,
  fetchCategories,
  fetchWeddingShopCategories,
  activePrimaryLink,
  activeSecondaryLink,
  disablePrimaryNavCollapse,
  disableSecondary,
  isWeddingBoutiquePage,
}) => {
  const fetchCategoriesAction = isWeddingBoutiquePage
    ? fetchWeddingShopCategories
    : fetchCategories;

  return Promise.all([!user ? fetchUserContext() : Promise.resolve(user), fetchCategoriesAction()])
    .then(([userContextResponse, categoriesResponse]) => {
      let userContext;
      let categories;
      let secondaryData;

      if (userContextResponse instanceof Error) {
        userContext = null;
      } else {
        userContext = userContextResponse;
      }
      if (categoriesResponse instanceof Error) {
        categories = [];
      } else {
        categories = categoriesResponse;
      }
      if (!disableSecondary) {
        if (isWeddingBoutiquePage) {
          secondaryData = new SecondaryNavWeddingShopData(userContext, categories).getItems();
        } else {
          secondaryData = new SecondaryNavRegistryData(userContext, categories).getItems();
        }
      }

      window.dispatchEvent(
        new CustomEvent('INIT_NAV_DATA', {
          detail: {
            secondaryData,
            userContext,
            showPromo,
            activePrimaryLink,
            activeSecondaryLink,
            disablePrimaryNavCollapse,
          },
        })
      );

      return [userContextResponse, userContextResponse];
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.log('Error fetching nav data', e);
    });
};

export default initNavData;
